import { Button } from "react-bootstrap";
import {
  CensusSelectedColumn,
  CensusSelectedColumnType,
} from "../../../types/Census/CensusSelectedColumn";

export interface SelectedColumnsProps {
  selectedColumns: CensusSelectedColumn[];
  onColumnClick: (selectedColumn: CensusSelectedColumn) => void;
}

const SelectedCensusColumns = ({
  selectedColumns,
  onColumnClick,
}: SelectedColumnsProps) => {
  return (
    <>
      <p className="mb-0 mt-2">Selected Columns</p>
      <div
        className="border 
        rounded 
        m-auto
        d-flex 
        flex-wrap 
        gap-2
        p-3
        justify-content-start 
        align-items-start"
        style={{ maxHeight: 120, overflowY: "scroll" }}>
        {selectedColumns.map((column, index) => (
          <Button
            key={index}
            variant="outline-info"
            size="sm"
            style={{ textAlign: "left" }}
            onClick={() => {
              onColumnClick(column);
            }}>
            {column.type === CensusSelectedColumnType.Category && (
              <b>{column.label}</b>
            )}
            {column.type === CensusSelectedColumnType.Individual &&
              column.label}
            {column.type === CensusSelectedColumnType.AgeBand && (
              <u>{column.label}</u>
            )}
          </Button>
        ))}
        {selectedColumns.length === 0 && (
          <p className="text-muted p-0 m-0">No columns selected</p>
        )}
      </div>
    </>
  );
};
export default SelectedCensusColumns;
